// extracted by mini-css-extract-plugin
export default {"back_arrow":"BackButton_back_arrow__hcMCJ","light":"BackButton_light__mw6R1"};